import { render } from "./StudentDetail.vue?vue&type=template&id=0c5e3ab5"
import script from "./StudentDetail.vue?vue&type=script&lang=js"
export * from "./StudentDetail.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__